import Vue from 'vue'
import Router from 'vue-router'

import { getCookie } from './cookiesHandler'

Vue.use(Router)

let router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'site-home',
      component: () => import('@/views/Site/Home.vue'),
      meta: { showCartLink: true }
    },

    {
      path: '/inicio',
      name: 'site-start',
      component: () => import('@/views/Site/Home.vue'),
      meta: { showCartLink: true }
    },

    {
      path: '/termos-de-uso',
      name: 'usage',
      component: () => import('@/views/Site/UsageTerms.vue'),
      meta: { showCartLink: true, showCompletionMessages: true }
    },

    {
      path: '/perfil/:id/:user',
      name: 'perfil-user',
      component: () => import('@/views/General/Perfil.vue'),
      meta: { showCartLink: true }
    },

    {
      path: '/painel',
      name: 'site-painel',
      component: () => import('@/views/Site/StartPage.vue'),
      meta: { requiresAuth: true, showCartLink: true }
    },

    {
      path: '/feed',
      name: 'feed',
      component: () => import('@/views/Site/Panel.vue'),
      meta: { requiresAuth: true, showCartLink: true }
    },

    {
      path: '/cursos',
      name: 'courses',
      component: () => import('@/views/Site/Courses.vue'),
      meta: { showCartLink: true }
    },

    {
      path: '/cursos/:name/:id/:author/:coupom?',
      name: 'course-data',
      component: () => import('@/views/Site/CourseData.vue'),
      meta: { showCartLink: true }
    },

    {
      path: '/meus/cursos',
      name: 'my-courses',
      component: () => import('@/views/Student/MyCourses.vue'),
      meta: { showCartLink: true }
    },

    {
      path: '/aluno',
      name: 'student-home',
      component: () => import('@/views/Student/Home.vue'),
      meta: { requiresAuth: true, showCartLink: true }
    },

    {
      path: '/professor/acesso',
      name: 'teacher-access',
      component: () => import('@/views/General/Login.vue'),
    },

    {
      path: '/professor',
      name: 'teacher-home',
      component: () => import('@/views/Teacher/Home.vue'),
      meta: { requiresAuth: true, showCartLink: true }
    },

    {
      path: '/professor/adicionar/curso',
      name: 'teacher-add-course',
      component: () => import('@/views/Teacher/Course/AddCourse.vue'),
      meta: { requiresAuth: true }
    },

    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/General/Login.vue'),
      // meta: { hideMenu: true }
    },

    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/General/Register.vue'),
      // meta: { hideMenu: true }
    },

    {
      path: '/logout',
      name: 'logout',
      component: () => import('@/views/General/Logout.vue'),
      meta: { hideMenu: true }
    },

    {
      path: '/reset',
      name: 'reset',
      component: () => import('@/views/General/Reset.vue'),
      meta: { hideMenu: true }
    },

    {
      path: '/reset/password',
      name: 'reset-password',
      component: () => import('@/views/General/ResetPassword.vue'),
      meta: { hideMenu: true }
    },

    {
      path: '/market',
      name: 'market',
      component: () => import('@/views/General/Market.vue'),
      meta: { hideMenu: true }
    },

    {
      path: '/showtime/:id',
      name: 'course-view',
      component: () => import('@/views/Student/ShowTime.vue'),
      meta: { requiresAuth: true, showCartLink: false, hideMenu: true }
    },

    {
      path: '/email/confirmation',
      name: 'email-confirmation',
      component: () => import('@/views/General/EmailConfirmation.vue'),
      meta: { requiresAuth: true }
    },

    {
      path: '/curso/:id/:name',
      name: 'course-edit',
      component: () => import('@/views/Teacher/Course/InfoCourse.vue'),
      meta: { requiresAuth: true, showCartLink: false }
    },

    {
      path: '/curso/:id/:name/:coop/co-produtor',
      name: 'coop-course-edit',
      component: () => import('@/views/Teacher/Course/InfoCoopCourse.vue'),
      meta: { requiresAuth: true, showCartLink: false }
    },

    {
      path: '*',
      name: 'error',
      component: () => import('@/views/Error/404.vue'),
      meta: { showCartLink: false }
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!getCookie('_ad02f725-a21b-4c57-910f-d1fea983ea00')) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
